module.exports = __webpack_public_path__ + "img/cooperation_unit_20.77c63152.jpg";